import { render, staticRenderFns } from "./phone-model-list.vue?vue&type=template&id=3053fcfc&scoped=true"
import script from "./phone-model-list.vue?vue&type=script&lang=js"
export * from "./phone-model-list.vue?vue&type=script&lang=js"
import style0 from "./phone-model-list.vue?vue&type=style&index=0&id=3053fcfc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3053fcfc",
  null
  
)

export default component.exports